/**
 * Provider Candidates Service
 * Endpoint: GET /api/v2/district/provider-candidates/
 *
 * Returns provider organizations ranked for an alert (or site): candidates
 * within configured coverage first, distance ascending within each coverage
 * group, and candidates without usable geometry last (distance_km=null,
 * has_geometry=false). Organizations already holding a live invitation for
 * the given alert are excluded server-side.
 */
import { client } from '../lib/http-client';

function unwrap<T>(result: { data?: T; error?: unknown }): T {
    if (result.error !== undefined) {
        throw result.error;
    }
    return result.data as T;
}

export interface ProviderCandidate {
    org_id: number;
    org_name: string;
    distance_km: number | null;
    within_coverage: boolean;
    has_geometry: boolean;
}

export interface PaginatedProviderCandidateList {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: ProviderCandidate[];
}

export interface GetProviderCandidatesParams {
    alert_id: number;
}

/**
 * GET /api/v2/district/provider-candidates/
 */
export async function getProviderCandidates(
    params: GetProviderCandidatesParams,
): Promise<PaginatedProviderCandidateList> {
    const result = await client.GET('/api/v2/district/provider-candidates/', {
        params: {
            query: {
                alert_id: params.alert_id,
            },
        },
    });
    return unwrap(result) as unknown as PaginatedProviderCandidateList;
}
